import { Component, OnInit, Input } from '@angular/core';
import { TranslateService, LangChangeEvent } from '@ngx-translate/core';
import { IdiomaService } from 'src/app/core/services/idioma.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})

export class HeaderComponent implements OnInit {
  @Input() data: any;
  @Input() pagina;

  idiomaSelecionado;
  idiomas;

  constructor(
    private translate: TranslateService,
    private idiomaService: IdiomaService
  ) {
    this.translate.onLangChange.subscribe((event: LangChangeEvent) => {
      this.idiomaSelecionado = this.idiomaService.getIdioma();
    });
  }

  ngOnInit() {
    this.idiomaSelecionado = this.idiomaService.getIdioma();
    this.idiomas = this.idiomaService.getIdiomas();
  }

  alterarIdioma(idioma: string) {
    this.translate.use(idioma);
  }
}
